import { heroTags } from "../../../mocks/guaData";

export default function Hero() {
  return (
    <section
      id="home"
      className="relative flex min-h-[88vh] w-full items-center overflow-hidden"
      aria-label="首屏品牌介绍"
    >
      <img
        src="https://readdy.ai/api/search-image?query=fresh%20summer%20watermelon%20and%20crisp%20green%20leaves%20on%20a%20soft%20cream%20background%2C%20bright%20airy%20composition%2C%20modern%20minimal%20still%20life%2C%20soft%20natural%20lighting%2C%20playful%20and%20fresh%20editorial%20style%2C%20high%20detail&width=1600&height=1000&seq=gua-hero-2026-a1&orientation=landscape"
        alt="夏日西瓜与翠绿叶片，象征轻松快乐的吃瓜氛围"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-background-50/95 via-background-50/70 to-background-50/20"></div>

      <div className="relative z-10 mx-auto w-full max-w-7xl px-4 py-16 md:px-6">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-semibold text-primary-700">
            <i className="ri-flashlight-fill text-xs" aria-hidden="true"></i>
            吃瓜神器 · 全网热点聚合工具实测
          </span>

          <h1 className="mt-5 font-heading text-3xl font-bold leading-tight text-foreground-950 md:text-5xl">
            吃瓜神器好用吗？
            <span className="block text-primary-600">一篇测评讲透值与不值</span>
          </h1>

          <p className="mt-5 text-base leading-relaxed text-foreground-700 md:text-lg">
            从下载安装到高阶玩法，吃瓜研究所结合真实体验与多维度评分，
            为你完整拆解吃瓜神器的功能、优缺点与适用人群，帮你判断它是否值得安装使用。
          </p>

          <div className="mt-6 flex flex-wrap gap-2">
            {heroTags.map((t) => (
              <span
                key={t}
                className="whitespace-nowrap rounded-md bg-background-100 px-3 py-1 text-xs font-medium text-foreground-600 ring-1 ring-background-200"
              >
                {t}
              </span>
            ))}
          </div>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <a
              href="#verdict"
              className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-center text-sm font-semibold text-white transition-colors hover:bg-primary-600"
            >
              查看实测结论
              <i className="ri-arrow-right-line ml-1.5" aria-hidden="true"></i>
            </a>
            <a
              href="#tutorial"
              className="whitespace-nowrap rounded-md bg-background-100 px-6 py-3 text-center text-sm font-semibold text-primary-700 ring-1 ring-primary-200 transition-colors hover:bg-primary-50"
            >
              开始上手教程
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}